import { useState } from "react";
import { Tabs } from "antd";
const { TabPane } = Tabs;
import PropTypes from "prop-types";

import { CannedQuestions } from "../canned-questions/CannedQuestions.jsx";
import { ChatContext } from "../chat-context/ChatContext.jsx";
import { ChatAppDocuments } from "../chat-app/ChatAppDocuments.jsx";
import { GridLayout } from "../grid-layout/GridLayout.jsx";

import "./LeftGrid.css";

function LeftGrid({ appId }) {
  const [activeKey, setActiveKey] = useState("1");

  const onTabChange = (key) => {
    setActiveKey(key);
  };

  const items = [
    {
      key: "1",
      label: "Chats",
      children: <ChatContext appId={appId} />,
    },
    {
      key: "2",
      label: "Canned Questions",
      children: <CannedQuestions appId={appId} />,
    },
    {
      key: "3",
      label: "Documents",
      children: <ChatAppDocuments appId={appId} />,
    },
  ];

  return (
    <GridLayout>
      <div className="grid-main-layout">
        <Tabs activeKey={activeKey} onChange={onTabChange} defaultActiveKey="1">
          {items.map((item) => (
            <TabPane
              tab={
                <span
                  className={`chat-tab ${
                    item.key === activeKey ? "chat-tab-active" : ""
                  }`}
                >
                  {item.label}
                </span>
              }
              key={item.key}
            >
              {item.children}
            </TabPane>
          ))}
        </Tabs>
      </div>
    </GridLayout>
  );
}

LeftGrid.propTypes = {
  appId: PropTypes.string.isRequired,
};

export { LeftGrid };
